import React, { useState } from "react";
import { Delete, Assessment } from "@mui/icons-material";
import DataTable from "../../../lib/components/DataTable";
import NotificationAnalyticsModal from "./notification-analytics-modal";

const NotificationsDataTable = ({
  data = [],
  isLoading,
  onDeleteNotification,
  page,
  pageSize,
  totalPages,
  onPageChange,
  onPageSizeChange,
}) => {
  const [selectedNotificationForAnalytics, setSelectedNotificationForAnalytics] = useState(null);

  if (isLoading) return null;

  /* -------------------------------------------------------------------------- */
  /* Columns                                                                    */
  /* -------------------------------------------------------------------------- */

  const columns = [
    {
      key: "title",
      header: "Message",
      render: (value) => <span className="fw-medium">{value ?? "N/A"}</span>,
    },
    {
      key: "status",
      header: "Status",
      type: "status",
    },
    {
      key: "createdAt",
      header: "Created On",
      type: "date",
      format: "Do MMM, YYYY",
    },
    {
      key: "deliveryTypes",
      header: "Delivery Type(s)",
      render: (value = []) => value.map((type) => type.replace("_", " ")).join(", "),
    },
  ];

  /* -------------------------------------------------------------------------- */
  /* Status Config                                                              */
  /* -------------------------------------------------------------------------- */

  const statusConfig = {
    SENT: {
      label: "Sent",
      className: "badge rounded-pill fw-medium fs-sm bg-success text-success bg-opacity-25",
    },
    SCHEDULED: {
      label: "Scheduled",
      className: "badge bg-warning text-warning rounded-pill fw-medium fs-sm bg-opacity-25",
    },
  };

  /* -------------------------------------------------------------------------- */
  /* Row Actions                                                                */
  /* -------------------------------------------------------------------------- */

  const rowActions = {
    actions: [
      {
        icon: <Assessment />,
        color: "primary",
        tooltip: "View delivery analytics",
        onClick: (row) => setSelectedNotificationForAnalytics(row),
      },
      {
        icon: <Delete />,
        color: "error",
        tooltip: "Delete notification",
        isDisabled: (row) => row.status === "SENT",
        onClick: (row) => onDeleteNotification(row),
      },
    ],
  };

  return (
    <>
      <DataTable
        data={data}
        columns={columns}
        statusConfig={{ status: statusConfig }}
        rowActions={rowActions}
        selectable={false}
        isLoading={isLoading}
        getRowId={(row) => row.id}
        page={page}
        pageSize={pageSize}
        totalPages={totalPages}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />

      {/* Delivery Analytics Modal */}
      <NotificationAnalyticsModal
        isOpen={!!selectedNotificationForAnalytics}
        onClose={() => setSelectedNotificationForAnalytics(null)}
        notification={selectedNotificationForAnalytics}
      />
    </>
  );
};

export default NotificationsDataTable;
